import { t } from 'i18next';
import { useCallback } from 'react';

import { FeatureFlags } from '~constants/featureFlags';
import { useFeatureFlag } from '~utils/hooks/useFeatureFlag';

export default function useDispatchNumberLabel() {
  const isRenameEnabled = useFeatureFlag({
    featureFlagKey: FeatureFlags.renameDispatchNoToCustomerRefPo,
  });

  const plural = useCallback(
    (fallbackKey: string) =>
      isRenameEnabled ? t('common.customer_ref_po_numbers') : t(fallbackKey),
    [isRenameEnabled],
  );

  const singular = useCallback(
    (fallbackKey: string) =>
      isRenameEnabled ? t('common.customer_ref_po') : t(fallbackKey),
    [isRenameEnabled],
  );

  return { plural, singular };
}
